<template>
  <div>
    <div class="content-wrapper">
      <label class="mr-2 select-label">{{ title }}</label>
      <v-select
        :style="scaleComboboxStyle"
        class="combo-box scale-combobox"
        variant="outlined"
        density="compact"
        :items="values"
        item-title="value"
        item-value="index"
        :model-value="modelValue"
        @update:modelValue="$emit('update:modelValue', $event)"
        hide-details
        return-object
      ></v-select>
      <label class="ml-2 select-label">{{ unit }}</label>
    </div>
  </div>
</template>

<script>
export default {
  name: "ScaleCombobox",
  emits: ["update:modelValue"],

  props: {
    values: Array,
    modelValue: Object,
    title: String,
    width: Number,
    unit: String
  },

  computed: {
    scaleComboboxStyle() {
      return {
        width: `${this.width}px`
      };
    }
  }
};
</script>

<style lang="scss" scoped>
@use "../../styles/combobox";

.content-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.select-label {
  font-size: 0.8em;
}
.scale-combobox {
  display: inline-block;
}
</style>
